import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { DatePipe } from '@angular/common';
import { GridTableParametersService } from 'src/app/template/gridTemplate/gridTableParameters.service';
import { GipReqManForm } from 'src/app/workflow/request/request.model';
import { ToPicklistPipe } from 'src/app/shared/pipes/toPicklistPipe.pipe';

import { FormularService } from 'src/app/Services/formular.service';
import { Router } from '@angular/router';
import { interval } from 'rxjs';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

declare function framesStore(): any;

@Component({
  selector: 'app-request-overview',
  templateUrl: './request-overview.component.html',
  styleUrls: ['./request-overview.component.css']
})
export class RequestOverviewComponent implements OnInit, OnDestroy {
  @Input() public childFormInput;
  @Output() public onSubmit = new EventEmitter();

  overviewForm;

  resourceDefinition;
  Picklist;
  V_GIP_PROCREQ_T;
  requestState = "";
  newRequestUploadFiles;

  Language;
  disableSubmitButton = false;
  sub;
  public intervalTimer = interval(3000)


  constructor(
    private shareData: SharingDataService,
    public datepipe: DatePipe,
    public grid: GridTableParametersService,
    public toPicklist: ToPicklistPipe,
    public formularService: FormularService,
    public router: Router,
    private errorHandlingService: ErrorHandlingService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    ) { }

    overviewFormular = [
      {formControlName : "G3E_FID",                        picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: "cptn_DisplayRequest"},
      {formControlName : "PERSON_ID",                      picklist: "V_MS_USER_VL",                 translationKey: "C_PERSON_ID",     autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "DELIVERY_STATE",                 picklist: "V_MS_DELIVERY_STATE_VL_T",                                        autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "REQUEST_STATE",                  picklist: "V_MS_REQUEST_STATE_VL_T",                                         autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},            
      {formControlName : "ACTIVITY_TYPE",                  picklist: "V_MS_ACTIVITY_TYPE_VL_T",                                         autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "REASON_TYPE",                    picklist: "V_MS_REASON_TYPE_VL_T",                                           autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},      
      {formControlName : "BEGIN_ACTIVITY_DT",              picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: true,    datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "END_ACTIVITY_DT",                picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: true,    datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "REQUEST_DT",                     picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: true,    datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "EXPIRATION_DT",                  picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: true,    datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "RESPONSIBLE_PERSON",             picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "RESPONSIBLE_PERSON_TEL_NUM",     picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "PERSON_EMAIL",                   picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "LOCATION",                       picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},      
      {formControlName : "LOCATION_DESC",                  picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},      
      {formControlName : "COMPANY",                        picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},      
      {formControlName : "REQUESTOR",                      picklist: "V_MS_USER_VL",                 translationKey: "C_REQUESTOR",     autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "",    title: null},
      {formControlName : "REQSTATBACKEND",                 picklist: null,                                                              autocomplete: null,     input: false,    required: false,    readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: true,  function: "",    title: "cptn_Status"},
    ]

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentLanguage.subscribe(data => this.Language = data);
    this.shareData.currentPicklist.subscribe(data => this.Picklist = data);
    this.shareData.currentnewRequestUploadFiles.subscribe(data => this.newRequestUploadFiles = data);
    
    var router = "";
    if(this.router.url.indexOf("?")>0){
      router = this.router.url.substr(0, this.router.url.indexOf("?"));
    } else {
      router = this.router.url;
    }

    if (router === '/gipReqOverview' || router === '/gipReqMan') {
      this.overviewForm = GipReqManForm;
    }
    if (router === '/newRequest') {
      this.overviewForm = this.childFormInput;
      this.overviewForm.reset();
    }
    this.overviewForm.controls.REQSTATBACKEND.setValue(this.translateResourceDefinition.transform('status_WaitingForSubmit', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "MS_REQ_N"))
  }

  ngOnDestroy() {
    try{
      this.sub.unsubscribe();
    } catch{}

  }

  submit() {
    this.onSubmit.emit();
    this.disableSubmitButton = true;

    var object = {};

    for(var element in this.childFormInput.value){
      if(element == "REQERR_NOTIF"){
        object[element] = +this.childFormInput.value[element];
      } else {
        object[element] = this.childFormInput.value[element];
      }
      if(element == "G3E_FNO"){object[element] = 950;}
      if(element == "G3E_CNO"){object[element] = 32701;}
      if(element == "G3E_ID"){object[element] = 0;}
      if(element == "G3E_FID" && this.childFormInput.value[element] == null){object[element] = 0;}
      if(element == "G3E_CID"){object[element] = 1;}
    }

    var model = {
      files: this.newRequestUploadFiles,
      request : object,
      features : framesStore()
    }

    console.log(model);
    this.overviewForm.controls.REQSTATBACKEND.setValue(this.translateResourceDefinition.transform('status_SendingRequest', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "MS_REQ_N"))
    this.formularService.postRequest(`plot/submitplot`, model, (data) => {
      this.overviewForm.controls.G3E_FID.setValue(data.g3e_fid);
      this.refreshProcReq();
      this.sub = this.intervalTimer.subscribe(() => this.refreshProcReq());
      this.formularService.getData([`Statistic/V_MS_STAT_ALL?$filter=G3E_FID eq ${data.g3e_fid}`], (stat) => {
        this.overviewForm.controls.DELIVERY_STATE.setValue(stat[0][0].DELIVERY_STATE)
        this.overviewForm.controls.REQUEST_STATE.setValue(stat[0][0].REQUEST_STATE)
      })
    }, this.handlePostError);
  }

  handlePostError(response: any){
    var error = '';

    if (response.status == 431){
      error = this.translateResourceDefinition.transform("FileTooLarge", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common")
      this.errorHandlingService.showError(error);
    } else if(response.status == 415){
      error = this.translateResourceDefinition.transform("UnsupportedMediaType", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common")
      this.errorHandlingService.showError(error);
    }
    else {
      error = this.formularService.getDefaultErrorMessage();
      this.errorHandlingService.showError(error);
    }
  }

  refreshProcReq(){
    if(this.overviewForm){
      this.formularService.getData([`data/GIP_PROCREQ?$filter=OBJECTID eq '${this.overviewForm.value.G3E_FID}' and endswith(COMMAND, 'PLOT')`], (procReqData) => {
        if(procReqData[0].length > 0){
          this.formularService.getData([`data/V_GIP_TEXT_T?$filter=TEXTID eq '${procReqData[0][0].TEXTID}' AND LANG eq '${this.Language}'`], (textData) => {
            if(textData[0].length > 0)
            this.overviewForm.controls.REQSTATBACKEND.setValue(textData[0][0].TEXT);
          });
        }
      });
    }
  }
}
